import {
  AssignStrategyRuleTypeEnum,
  ManualReviewDescriptionTypeEnum,
  ManualReviewDividerTypeEnum,
  ManualReviewFieldTypeEnum,
} from "src/clients/flow-api";
import { ManualReviewNodeData } from "src/constants/NodeDataTypes";
import { SearchableField } from "src/flowGraph/canvasSearch/extractNodeFields";
import { extractClauses } from "src/flowGraph/canvasSearch/nodesExtractors/utils";
import { assertUnreachable } from "src/utils/typeUtils";

export const extractManualReviewNodeFields = (
  data: ManualReviewNodeData,
  nodeId: string,
): SearchableField[] => {
  const fields: SearchableField[] = [];

  const [fileHighlights, otherHighlights] = [
    data.highlights.filter((highlight) => highlight.type === "file"),
    data.highlights.filter((highlight) => highlight.type !== "file"),
  ];

  otherHighlights.forEach((highlight) => {
    switch (highlight.type) {
      case ManualReviewFieldTypeEnum.FIELD:
        fields.push({
          id: highlight.id_readable_name,
          value: highlight.readable_name,
        });
        fields.push({
          id: highlight.id_value,
          value: highlight.value,
        });
        break;

      case ManualReviewDescriptionTypeEnum.DESCRIPTION:
        fields.push({
          id: highlight.id_value,
          value: highlight.value,
        });
        break;

      case ManualReviewDividerTypeEnum.DIVIDER:
        break;

      default:
        assertUnreachable(highlight);
        return;
    }
  });

  fileHighlights.forEach((highlight) => {
    fields.push({
      id: highlight.id_value,
      value: highlight.value,
    });
  });

  if (data.response_form.description) {
    fields.push({
      id: `${nodeId}:response_form:description`,
      value: data.response_form.description,
    });
  }

  data.response_form.fields?.forEach((field) => {
    if (field.key) {
      fields.push({
        id: `${field.id}:key`,
        value: `data.${field.key}`,
      });
    }

    if (field.name) {
      fields.push({
        id: `${field.id}:name`,
        value: field.name,
      });
    }

    if (field.enum) {
      field.enum.forEach((enumValue, index) => {
        fields.push({
          id: `${field.id}:enum:${index}`,
          value: enumValue as string,
        });
      });
    }
  });

  if (data.response_metadata_key) {
    fields.push({
      id: `${nodeId}:response_metadata_key`,
      value: `data.${data.response_metadata_key}`,
    });
  }

  if (
    data.reviewer_assign_strategy_v2?.type === AssignStrategyRuleTypeEnum.RULE
  ) {
    data.reviewer_assign_strategy_v2.branches.forEach((branch) => {
      fields.push(...extractClauses(branch.clauses));
    });
  }

  return fields;
};
